export default "__VITE_ASSET__56b7a141__"